export const BANKING_CASE_TAXONOMY_CONFIG = {
  id: 'banking_financial_recovery',
  label: 'Banking / Financial Recovery',
  shortLabel: 'Banking',
  description: 'Banking suits, recovery claims, finance defaults, mortgage, pledge, hypothecation, execution of banking decrees, banking appeals, and related financial recovery proceedings.',
  active: true,
  types: [
    {
      id: 'Banking Suit',
      label: 'Banking Suit',
      shortLabel: 'Banking Suit',
      description: 'Suit by a financial institution or borrower/customer concerning recovery of finance, declaration, rendition of accounts, enforcement of banking liability, or banking relationship dispute.',
      subtypes: [
        'Suit for Recovery by Financial Institution',
        'Suit by Customer / Borrower',
        'Suit for Declaration Against Bank',
        'Suit for Rendition of Accounts',
        'Suit for Settlement / Adjustment of Liability',
        'Suit for Damages Against Bank',
        'Suit Concerning Finance Agreement',
        'Suit Concerning Statement of Account',
        'Other Banking Suit',
        'Other'
      ],
      sideOptions: ['Financial Institution / Plaintiff', 'Customer / Defendant', 'Borrower', 'Guarantor', 'Mortgagor', 'Applicant', 'Respondent'],
      documentTabs: ['All', 'Documents', 'Applications', 'Orders', 'Miscellaneous'],
      defaultStages: ['Case Preparation', 'Filing', 'Notice to Defendant', 'Defendant Appearance', 'Written Statement', 'Evidence', 'Arguments', 'Judgment / Decree', 'Execution / Appeal', 'Closed']
    },
    {
      id: 'Financial Recovery Suit',
      label: 'Financial Recovery Suit',
      shortLabel: 'Recovery',
      description: 'Proceedings for recovery of outstanding amount, financed amount, loan, mark-up, lease amount, business finance, credit facility, or other financial liability.',
      subtypes: [
        'Recovery of Loan Amount',
        'Recovery of Finance Facility',
        'Recovery of Mark-Up / Profit',
        'Recovery of Lease Finance',
        'Recovery of Credit Card / Consumer Finance',
        'Recovery of Running Finance / Cash Finance',
        'Recovery of Business Loan',
        'Recovery Against Guarantor',
        'Recovery Against Principal Borrower',
        'Other Financial Recovery',
        'Other'
      ],
      sideOptions: ['Claimant / Financial Institution', 'Borrower / Defendant', 'Guarantor', 'Customer', 'Applicant', 'Respondent'],
      documentTabs: ['All', 'Documents', 'Applications', 'Orders', 'Miscellaneous'],
      defaultStages: ['Case Preparation', 'Filing', 'Notice to Defendant', 'Defendant Appearance', 'Written Statement', 'Evidence', 'Arguments', 'Judgment / Decree', 'Execution / Appeal', 'Closed']
    },
    {
      id: 'Mortgage / Pledge / Hypothecation Matter',
      label: 'Mortgage / Pledge / Hypothecation Matter',
      shortLabel: 'Security Matter',
      description: 'Proceedings concerning enforcement, redemption, sale, release, attachment, or dispute regarding mortgaged, pledged, charged, or hypothecated property/security.',
      subtypes: [
        'Mortgage Enforcement',
        'Redemption of Mortgage',
        'Sale of Mortgaged Property',
        'Release of Mortgaged Property',
        'Pledge Enforcement',
        'Release of Pledged Goods',
        'Hypothecated Assets Dispute',
        'Charge / Security Dispute',
        'Guarantor Security Dispute',
        'Other Security Matter',
        'Other'
      ],
      sideOptions: ['Financial Institution', 'Borrower', 'Mortgagor', 'Guarantor', 'Pledgor', 'Pledgee', 'Applicant', 'Respondent'],
      documentTabs: ['All', 'Documents', 'Applications', 'Orders', 'Miscellaneous'],
      defaultStages: ['Case Preparation', 'Filing', 'Notice to Defendant', 'Defendant Appearance', 'Written Statement', 'Evidence', 'Arguments', 'Judgment / Decree', 'Execution / Appeal', 'Closed']
    },
    {
      id: 'Loan / Finance Default Matter',
      label: 'Loan / Finance Default Matter',
      shortLabel: 'Finance Default',
      description: 'Matters relating to default under loan, finance, lease, credit facility, running finance, cash finance, guarantee, or settlement/rescheduling arrangement.',
      subtypes: [
        'Default in Loan Repayment',
        'Default in Finance Facility',
        'Default in Lease Finance',
        'Default in Running Finance',
        'Default in Cash Finance',
        'Default in Credit Card / Consumer Finance',
        'Default by Guarantor',
        'Default in Settlement / Rescheduling',
        'Classification as Defaulter',
        'Other Finance Default',
        'Other'
      ],
      sideOptions: ['Financial Institution', 'Borrower', 'Guarantor', 'Customer', 'Applicant', 'Respondent'],
      documentTabs: ['All', 'Documents', 'Applications', 'Orders', 'Miscellaneous'],
      defaultStages: ['Case Preparation', 'Filing', 'Notice to Defendant', 'Defendant Appearance', 'Written Statement', 'Evidence', 'Arguments', 'Judgment / Decree', 'Execution / Appeal', 'Closed']
    },
    {
      id: 'Banking Execution',
      label: 'Banking Execution',
      shortLabel: 'Execution',
      description: 'Execution proceedings for enforcement of banking decree, recovery decree, sale of mortgaged property, attachment, auction, recovery of decretal amount, or implementation of banking court order.',
      subtypes: [
        'Execution of Banking Decree',
        'Execution of Recovery Decree',
        'Sale of Mortgaged Property',
        'Attachment of Property',
        'Auction Proceedings',
        'Recovery of Decretal Amount',
        'Execution Against Guarantor',
        'Objections to Banking Execution',
        'Satisfaction / Adjustment of Decree',
        'Other Banking Execution',
        'Other'
      ],
      sideOptions: ['Decree Holder / Financial Institution', 'Judgment Debtor / Borrower', 'Guarantor', 'Objector', 'Auction Purchaser', 'Applicant', 'Respondent'],
      documentTabs: ['All', 'Documents', 'Applications', 'Orders', 'Miscellaneous'],
      defaultStages: ['Case Preparation', 'Filing', 'Notice to Judgment Debtor', 'Objections', 'Reply to Objections', 'Certificate / Attachment Order', 'Sale Proceedings', 'Satisfaction / Partial Satisfaction', 'Disposal', 'Closed']
    },
    {
      id: 'Banking Appeal',
      label: 'Banking Appeal',
      shortLabel: 'Appeal',
      description: 'Appeal against banking court judgment, decree, order, execution order, or related financial recovery order where maintainable.',
      subtypes: [
        'Appeal Against Banking Decree',
        'Appeal Against Banking Judgment',
        'Appeal Against Interim Order',
        'Appeal Against Execution Order',
        'Appeal Against Sale / Auction Order',
        'Appeal Against Dismissal of Suit',
        'Appeal Against Leave to Defend Order',
        'Appeal Against Refusal of Leave to Defend',
        'Other Banking Appeal',
        'Other'
      ],
      sideOptions: ['Appellant', 'Respondent', 'Financial Institution', 'Borrower', 'Guarantor'],
      documentTabs: ['All', 'Documents', 'Applications', 'Orders', 'Miscellaneous'],
      defaultStages: ['Case Preparation', 'Filing', 'Scrutiny', 'Admission / Preliminary Hearing', 'Notice to Respondent', 'Record Summoned', 'Stay Application', 'Arguments', 'Judgment', 'Further Remedy', 'Closed']
    },
    {
      id: 'Banking Revision / Constitutional Challenge',
      label: 'Banking Revision / Constitutional Challenge',
      shortLabel: 'Revision / Writ',
      description: 'Revision, constitutional petition, or writ challenge against banking court order, execution order, auction/sale order, financial institution action, or other banking forum decision where maintainable.',
      subtypes: [
        'Writ Against Banking Court Order',
        'Challenge to Banking Decree',
        'Challenge to Execution Proceedings',
        'Challenge to Auction / Sale',
        'Challenge to Financial Institution Action',
        'Challenge to Refusal of Leave to Defend',
        'Challenge to Recovery Proceedings',
        'Challenge to Jurisdiction',
        'Other Banking Challenge',
        'Other'
      ],
      sideOptions: ['Petitioner', 'Respondent', 'Financial Institution', 'Borrower', 'Guarantor', 'Objector'],
      documentTabs: ['All', 'Documents', 'Applications', 'Orders', 'Miscellaneous'],
      defaultStages: ['Case Preparation', 'Filing', 'Scrutiny', 'Admission / Preliminary Hearing', 'Notice to Respondent', 'Record Summoned', 'Stay Application', 'Arguments', 'Judgment', 'Further Remedy', 'Closed']
    },
    {
      id: 'Banking Miscellaneous Application',
      label: 'Banking Miscellaneous Application',
      shortLabel: 'Application',
      description: 'Connected or standalone applications in banking/financial recovery proceedings, including leave to defend, stay, condonation of delay, setting aside ex parte decree, execution objections, auction objections, attachment, sale, or early hearing.',
      subtypes: [
        'Application for Leave to Defend',
        'Application for Stay',
        'Application for Condonation of Delay',
        'Application for Setting Aside Ex Parte Decree',
        'Application for Attachment',
        'Application for Sale / Auction',
        'Objections to Auction',
        'Objections to Execution',
        'Application for Release of Property',
        'Application for Settlement / Compromise',
        'Application for Early Hearing',
        'Other Banking Application',
        'Other'
      ],
      sideOptions: ['Applicant', 'Respondent', 'Financial Institution', 'Borrower', 'Guarantor', 'Objector'],
      documentTabs: ['All', 'Documents', 'Applications', 'Orders', 'Miscellaneous'],
      defaultStages: ['Case Preparation', 'Filing', 'Scrutiny', 'Admission / Preliminary Hearing', 'Notice to Respondent', 'Record Summoned', 'Stay Application', 'Arguments', 'Judgment', 'Further Remedy', 'Closed']
    },
    {
      id: 'Other Banking / Financial Matter',
      label: 'Other Banking / Financial Matter',
      shortLabel: 'Other Banking',
      description: 'Use this for banking, finance, loan, credit facility, security, recovery, or financial institution matters that do not fit the available banking case types.',
      subtypes: [
        'Custom Banking Matter',
        'Custom Financial Recovery Matter',
        'Other'
      ],
      sideOptions: ['Party A', 'Party B', 'Financial Institution', 'Borrower', 'Guarantor', 'Applicant', 'Respondent'],
      documentTabs: ['All', 'Documents', 'Applications', 'Orders', 'Miscellaneous'],
      defaultStages: ['Case Preparation', 'Filing', 'Notice', 'Reply', 'Evidence', 'Arguments', 'Order', 'Closed']
    }
  ]
};

export const normalizeBankingCaseClassification = (existingCase: any) => {
  if (!existingCase) return existingCase;

  const labels = [
    existingCase.caseCategory,
    existingCase.caseType,
    existingCase.matterType,
    existingCase.subType,
    existingCase.caseSubtype,
    ...(existingCase.tags || [])
  ].filter(Boolean).map(s => s.toLowerCase());

  const hasLabel = (term: string) => labels.some(l => l.includes(term.toLowerCase()));

  // If already mapped to new structure
  if (existingCase.caseCategory === 'Banking / Financial Recovery') {
    return existingCase;
  }

  // Check if it's a banking case
  const isBanking = hasLabel('banking') || hasLabel('recovery suit') || hasLabel('loan recovery') || hasLabel('finance recovery') || hasLabel('mortgage') || hasLabel('pledge') || hasLabel('hypothecation') || hasLabel('loan default') || hasLabel('guarantor default');
  
  if (!isBanking) return existingCase; // Not a banking case

  const newCase = { ...existingCase, legacyCaseType: existingCase.caseType || existingCase.matterType };
  newCase.caseCategory = 'Banking / Financial Recovery';
  
  if (hasLabel('writ against banking') || hasLabel('challenge to banking') || hasLabel('banking revision') || hasLabel('challenge to auction')) {
    newCase.caseType = 'Banking Revision / Constitutional Challenge';
    if (hasLabel('writ')) newCase.caseSubtype = 'Writ Against Banking Court Order';
    else if (hasLabel('auction') || hasLabel('sale')) newCase.caseSubtype = 'Challenge to Auction / Sale';
    else if (hasLabel('decree')) newCase.caseSubtype = 'Challenge to Banking Decree';
    else newCase.caseSubtype = 'Other Banking Challenge';
  } else if (hasLabel('leave to defend') || hasLabel('stay in banking') || hasLabel('setting aside ex parte banking') || hasLabel('objections to auction') || hasLabel('banking application') || hasLabel('banking miscellaneous')) {
    newCase.caseType = 'Banking Miscellaneous Application';
    if (hasLabel('leave to defend')) newCase.caseSubtype = 'Application for Leave to Defend';
    else if (hasLabel('stay')) newCase.caseSubtype = 'Application for Stay';
    else if (hasLabel('setting aside')) newCase.caseSubtype = 'Application for Setting Aside Ex Parte Decree';
    else if (hasLabel('objections to auction')) newCase.caseSubtype = 'Objections to Auction';
    else newCase.caseSubtype = 'Other Banking Application';
  } else if (hasLabel('execution of banking') || hasLabel('recovery of decretal') || hasLabel('auction proceedings') || hasLabel('objections to banking execution') || hasLabel('banking execution')) {
    newCase.caseType = 'Banking Execution';
    if (hasLabel('banking decree')) newCase.caseSubtype = 'Execution of Banking Decree';
    else if (hasLabel('decretal amount')) newCase.caseSubtype = 'Recovery of Decretal Amount';
    else if (hasLabel('auction')) newCase.caseSubtype = 'Auction Proceedings';
    else if (hasLabel('objections')) newCase.caseSubtype = 'Objections to Banking Execution';
    else newCase.caseSubtype = 'Other Banking Execution';
  } else if (hasLabel('appeal against banking') || hasLabel('appeal against execution') || hasLabel('banking appeal')) {
    newCase.caseType = 'Banking Appeal';
    if (hasLabel('decree')) newCase.caseSubtype = 'Appeal Against Banking Decree';
    else if (hasLabel('judgment')) newCase.caseSubtype = 'Appeal Against Banking Judgment';
    else if (hasLabel('execution')) newCase.caseSubtype = 'Appeal Against Execution Order';
    else if (hasLabel('leave to defend')) newCase.caseSubtype = 'Appeal Against Leave to Defend Order';
    else newCase.caseSubtype = 'Other Banking Appeal';
  } else if (hasLabel('mortgage') || hasLabel('pledge') || hasLabel('hypothecation')) {
    newCase.caseType = 'Mortgage / Pledge / Hypothecation Matter';
    if (hasLabel('mortgage enforcement')) newCase.caseSubtype = 'Mortgage Enforcement';
    else if (hasLabel('sale of mortgaged property')) newCase.caseSubtype = 'Sale of Mortgaged Property';
    else if (hasLabel('pledge case')) newCase.caseSubtype = 'Pledge Enforcement';
    else if (hasLabel('hypothecation case')) newCase.caseSubtype = 'Hypothecated Assets Dispute';
    else newCase.caseSubtype = 'Other Security Matter';
  } else if (hasLabel('loan default') || hasLabel('finance default') || hasLabel('running finance default') || hasLabel('guarantor default') || hasLabel('default in')) {
    newCase.caseType = 'Loan / Finance Default Matter';
    if (hasLabel('loan default') || hasLabel('default in loan')) newCase.caseSubtype = 'Default in Loan Repayment';
    else if (hasLabel('finance default') || hasLabel('default in finance')) newCase.caseSubtype = 'Default in Finance Facility';
    else if (hasLabel('running finance')) newCase.caseSubtype = 'Default in Running Finance';
    else if (hasLabel('guarantor')) newCase.caseSubtype = 'Default by Guarantor';
    else newCase.caseSubtype = 'Other Finance Default';
  } else if (hasLabel('recovery suit') || hasLabel('loan recovery') || hasLabel('finance recovery') || hasLabel('mark-up recovery') || hasLabel('lease finance recovery') || hasLabel('credit card recovery') || hasLabel('recovery against guarantor')) {
    newCase.caseType = 'Financial Recovery Suit';
    if (hasLabel('loan recovery')) newCase.caseSubtype = 'Recovery of Loan Amount';
    else if (hasLabel('finance recovery')) newCase.caseSubtype = 'Recovery of Finance Facility';
    else if (hasLabel('mark-up')) newCase.caseSubtype = 'Recovery of Mark-Up / Profit';
    else if (hasLabel('lease')) newCase.caseSubtype = 'Recovery of Lease Finance';
    else if (hasLabel('credit') || hasLabel('consumer')) newCase.caseSubtype = 'Recovery of Credit Card / Consumer Finance';
    else if (hasLabel('guarantor')) newCase.caseSubtype = 'Recovery Against Guarantor';
    else newCase.caseSubtype = 'Other Financial Recovery';
  } else if (hasLabel('suit by financial institution') || hasLabel('suit by bank') || hasLabel('suit for recovery by bank') || hasLabel('suit against bank') || hasLabel('rendition of accounts against bank') || hasLabel('banking suit')) {
    newCase.caseType = 'Banking Suit';
    if (hasLabel('suit for recovery') || hasLabel('suit by financial institution') || hasLabel('suit by bank')) newCase.caseSubtype = 'Suit for Recovery by Financial Institution';
    else if (hasLabel('suit against bank') || hasLabel('suit by customer')) newCase.caseSubtype = 'Suit by Customer / Borrower';
    else if (hasLabel('rendition of accounts')) newCase.caseSubtype = 'Suit for Rendition of Accounts';
    else newCase.caseSubtype = 'Other Banking Suit';
  } else {
    newCase.caseType = 'Other Banking / Financial Matter';
    newCase.caseSubtype = 'Custom Banking Matter';
  }

  return newCase;
};
